export default __webpack_public_path__ + "static/media/Manufacturer name 1.169a893c.png";